import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { EBillHeaderComponent } from '@ruby/modules/ebill/component/ebill-header/ebill-header.component';
import { EBillHeaderContainer } from '@ruby/modules/ebill/containers/ebill-header/ebill-header.container';
import { EBillContainer } from '@ruby/modules/ebill/containers/ebill.container';
import { EBillRoutingModule } from '@ruby/modules/ebill/ebill-routing.module';
import * as fromEBIll from '@ruby/modules/ebill/store';
import { EBillNotesDialogModule } from '@ruby/shared/dialogs/ebill/ebill-notes/ebill-notes.dialog.module';

@NgModule({
  declarations: [
    EBillContainer,
    EBillHeaderContainer,
    EBillHeaderComponent
  ],
  imports: [
    CommonModule,
    EBillRoutingModule,
    EBillNotesDialogModule,
    FormsModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatTooltipModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromEBIll.featureKey, fromEBIll.reducer),
    EffectsModule.forFeature(fromEBIll.effects)
  ],
  exports: [
    EBillContainer
  ]
})
export class EBillModule {}
